import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledCardAwardBadge = styled.div`
  .award-image {
    width: ${toRem(176)};
    margin: ${toRem(24)} auto ${toRem(0)} auto;
    display: flex;
  }
  .award-image-mobile {
    width: ${toRem(96)};
  }
  .award-legal-text p {
    margin-bottom: ${toRem(0)};
  }
`;
